import { render, staticRenderFns } from "./WapDet1.vue?vue&type=template&id=44091492&scoped=true&"
var script = {}
import style0 from "./WapDet1.vue?vue&type=style&index=0&id=44091492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44091492",
  null
  
)

export default component.exports